module.exports = __webpack_public_path__ + "fonts/DM_Sans-600-latin13.7c87a64.woff2";